import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getToken, getTokenMember } from "../../utils/app.utils";
import { AuthApi } from "../../api/auth/auth.api";

interface ProfileState {
  profile: UserProfile | null;
  loading: boolean;
  error: string;
}

interface Permission {
  code: string;
  permit: boolean;
}

interface UserProfile {
  employeeFirstname: string;
  employeeLastname: string;
  permission: Permission[];
  user_type?: string;
}

const initialState: ProfileState = {
  profile: null,
  loading: false,
  error: "",
};
export const profileAsync = createAsyncThunk<UserProfile>(
  "profile",
  async () => {
    try {
      const token_member = await getTokenMember();
      const token = await getToken();
      if (token || token_member) {
        const res = await AuthApi.getUser(token || token_member || "");
        if (res.data.success) {
          return res.data.data;
        }
      } else {
        return null;
      }
    } catch (error) {
      throw error;
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfile: (state) => {
      state.profile = null;
      state.loading = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(profileAsync.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(profileAsync.fulfilled, (state, action) => {
        state.profile = action.payload;
        state.loading = false;
        state.error = "";
      })
      .addCase(profileAsync.rejected, (state: any, action) => {
        state.profile = null;
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export const { clearProfile } = profileSlice.actions;
export default profileSlice.reducer;
